import { Grid, Stack, Title } from '@mantine/core';
import { UseFormReturnType } from '@mantine/form';

import { Declaration } from '@e-origin/shared';

import { EucdmCode, MultiLangCodes, TextInput } from '@components';
import { useCodeListSystem } from '@hooks/useCodeListSystem';
import { DeclarationStakeholdersFormValues } from './validateDeclarationStakeholdersForm';

interface StakeholderConsigneeSectionProps {
  form: UseFormReturnType<DeclarationStakeholdersFormValues>;
  editDisabled?: boolean;
  declaration: Declaration;
  declarationGroup: string;
}

export const StakeholderConsigneeSection: React.FC<StakeholderConsigneeSectionProps> = ({ form, editDisabled, declaration, declarationGroup }) => {
  const codelistSystems = useCodeListSystem({
    group: declarationGroup,
    isExport: declaration?.generalInfo?.isExport,
  });

  return (
    <Stack mb="xl">
      <Title order={5} fw={600}>
        Consignee
      </Title>

      <Grid>
        <Grid.Col span={6}>
          <EucdmCode path="stakeholders.consignee.name">
            <TextInput {...form.getInputProps('stakeholders.consignee.name')} label="Name" disabled={editDisabled} />
          </EucdmCode>
        </Grid.Col>
        <Grid.Col span={6}>
          <EucdmCode path="stakeholders.consignee.identificationNumber">
            <TextInput {...form.getInputProps('stakeholders.consignee.identificationNumber')} label="Identification number" disabled={editDisabled} />
          </EucdmCode>
        </Grid.Col>
      </Grid>

      <Grid>
        <Grid.Col span={3}>
          <EucdmCode path="stakeholders.consignee.address.street">
            <TextInput {...form.getInputProps('stakeholders.consignee.address.street')} label="Street and number" disabled={editDisabled} />
          </EucdmCode>
        </Grid.Col>
        <Grid.Col span={3}>
          <EucdmCode path="stakeholders.consignee.address.postcode">
            <TextInput {...form.getInputProps('stakeholders.consignee.address.postcode')} label="Postcode" disabled={editDisabled} />
          </EucdmCode>
        </Grid.Col>
        <Grid.Col span={3}>
          <EucdmCode path="stakeholders.consignee.address.city">
            <TextInput {...form.getInputProps('stakeholders.consignee.address.city')} label="City" disabled={editDisabled} />
          </EucdmCode>
        </Grid.Col>
        <Grid.Col span={3}>
          <EucdmCode path="stakeholders.consignee.address.country">
            <MultiLangCodes
              {...form.getInputProps('stakeholders.consignee.address.country')}
              label="Country"
              code="CL199"
              disabled={editDisabled}
              system={codelistSystems}
            />
          </EucdmCode>
        </Grid.Col>
      </Grid>
    </Stack>
  );
};
